const EMAIL_REGEX =
	// eslint-disable-next-line no-useless-escape
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ValidatorService = {
	validateEmail({ email }: { email: string }): boolean {
		return EMAIL_REGEX.test(email.trim());
	},

	validatePassword({ password, minLength = 8 }: { password: string; minLength?: number }): boolean {
		return password.length >= minLength;
	},

	isNonEmpty({ value }: { value: string | null | undefined }): boolean {
		return typeof value === 'string' && value.trim().length > 0;
	},
};

export default ValidatorService;
